module.exports = __webpack_public_path__ + "img/67_10.a94e8003.png";